import {gpsControlAllows,validGpsSetting} from './gps-control-profile.js';
import {reportedGpsParameters} from './gps-parameters.js';
import {gpsIntervalReadbackStatus} from './gps-interval-verification.js';

export function reportedGpsSetting(profile,action,reply){
 if(!gpsControlAllows(profile,action)||!['sleep','acc'].includes(action))return null;
 const fields=reportedGpsParameters(reply,{profile,query:action}),key=action==='sleep'?'sleepMinutes':'accMode';
 if(fields.length!==1||fields[0].key!==key)return null;
 const value=Number(fields[0].value);return validGpsSetting(value,action)?value:null;
}
export function gpsSettingReadbackStatus(profile,action,expected,reply){
 if(action==='interval')return gpsIntervalReadbackStatus(profile,expected,reply);
 if(!validGpsSetting(expected,action))return 'unconfirmed';
 const reported=reportedGpsSetting(profile,action,reply);
 return reported===null?'unconfirmed':reported===expected?'confirmed':'mismatch';
}
export function gpsVerifiedSettingFeedback(verification,danish){
 const status=verification?.status;
 const messages=status==='confirmed'
  ? ['Indstillingen er gemt og bekræftet af trackeren.','The setting is saved and confirmed by the tracker.']
  :status==='mismatch'
   ? ['Trackeren har gemt en anden værdi end den valgte. Ændringen er ikke bekræftet.','The tracker reports a different value from your selection. The change is not confirmed.']
   :status==='pending'
    ? ['Gemmer og kontrollerer indstillingen…','Saving and checking the setting…']
    : ['Bekræftelsen mangler. Indstillingen kan være ændret, men kunne ikke kontrolleres.','Confirmation is missing. The setting may have changed, but could not be checked.'];
 return {success:status==='confirmed',message:messages[danish?0:1]};
}
